import { gql } from '@apollo/client';

export const ADD_VISITOR_GROUP_V2 = gql`
  mutation AddVisitorGroupV2($name: String!, $type: String!, $maxNumberOfMembers: Int) {
    addVisitorGroup(name: $name, type: $type, maxNumberOfMembers: $maxNumberOfMembers) {
      id
      name
      members {
        id
        name
        email
        mobileDevices {
          id
          isRegistered
          registrationToken
          registrationDate
          role
        }
        isEditable
        expirationDate
        isAdmin
      }
      type
      externalRef
      maxNumberOfMembers
    }
  }
`;

export const ADD_VISITOR_WITH_ROLE = gql`
  mutation AddVisitorWithRole(
    $email: AWSEmail!
    $name: String!
    $visitorGroupMembership: [VisitorGroupMembershipInput!]
  ) {
    addVisitor(email: $email, name: $name, visitorGroupMembership: $visitorGroupMembership) {
      id
      name
      email
      mobileDevices {
        id
        isRegistered
        registrationToken
        registrationDate
        role
      }
      isEditable
      expirationDate
      isAdmin
      visitorGroupMembership {
        visitorGroup {
          id
          type
        }
        role
        expirationDate
      }
    }
  }
`;

export const DELETE_VISITOR_BY_ID = gql`
  mutation DeleteVisitorById($visitorId: ID!) {
    deleteVisitorById(visitorId: $visitorId)
  }
`;

export const DELETE_VISITOR_GROUP_BY_ID = gql`
  mutation DeleteVisitorGroupById($visitorGroupId: ID!, $options: MemberDeleteOptions!) {
    deleteVisitorGroupById(visitorGroupId: $visitorGroupId, options: $options)
  }
`;

export const SEND_INVITATION_FOR_MOBILE_DEVICE_BY_ID = gql`
  mutation SendInvitationForMobileDeviceById($visitorId: ID!, $mobileDeviceId: ID!) {
    sendInvitationForMobileDeviceById(visitorId: $visitorId, mobileDeviceId: $mobileDeviceId)
  }
`;

export const SET_VISITOR_BY_ID_WITH_ROLE = gql`
  mutation SetVisitorByIdWithRole(
    $visitorId: ID!
    $name: String!
    $visitorGroupMembership: [VisitorGroupMembershipInput!]!
  ) {
    setVisitorById(visitorId: $visitorId, name: $name, visitorGroupMembership: $visitorGroupMembership) {
      id
      name
      email
      mobileDevices {
        id
        isRegistered
        registrationToken
        registrationDate
        role
      }
      isEditable
      expirationDate
      isAdmin
      visitorGroupMembership {
        visitorGroup {
          id
          type
        }
        role
        expirationDate
      }
    }
  }
`;

export const UNREGISTER_MOBILE_DEVICE_BY_ID = gql`
  mutation UnregisterMobileDeviceById($visitorId: ID!, $mobileDeviceId: ID!) {
    unregisterMobileDeviceById(visitorId: $visitorId, mobileDeviceId: $mobileDeviceId)
  }
`;

export const UPDATE_ACCESS_GRANT = gql`
  mutation UpdateAccessGrant($accessGrantId: ID!, $input: UpdateAccessGrantInput!) {
    updateAccessGrant(accessGrantId: $accessGrantId, input: $input) {
      id
      accessSchedule {
        ... on WeekSchedule {
          weekDays {
            dayName
            from
            to
          }
        }
      }
    }
  }
`;

export const ADD_REST_API_KEY = gql`
  mutation AddRestApiKey($description: String!) {
    addRestApiKey(description: $description) {
      apiKey
      createdAt
      description
      id
    }
  }
`;

export const DELETE_REST_API_KEY = gql`
  mutation DeleteRestApiKey($id: ID!) {
    deleteRestApiKey(id: $id)
  }
`;

export const UPDATE_REST_API_KEY = gql`
  mutation UpdateRestApiKey($id: ID!, $description: String!) {
    updateRestApiKey(id: $id, description: $description) {
      apiKey
      createdAt
      description
      id
    }
  }
`;

export const ADD_DEVICE_GROUP = gql`
  mutation AddDeviceGroup($location: LocationInput!) {
    addLocation(location: $location) {
      id
      name
      doors {
        id
        name
      }
    }
  }
`;

export const ASSIGN_DEVICE_GROUP_TO_ACCESS_GRANTS = gql`
  mutation AssignDeviceGroupToAccessGrants($accessGrantIds: [ID!]!, $doorIds: [ID!]!, $locationIds: [ID!]!) {
    assignToAccessGrants(accessGrantIds: $accessGrantIds, doorIds: $doorIds, locationIds: $locationIds) {
      id
      locations {
        id
        name
      }
    }
  }
`;

export const UPDATE_DEVICE_GROUP = gql`
  mutation UpdateDeviceGroup($id: ID!, $location: LocationInput!) {
    updateLocation(id: $id, location: $location) {
      id
      name
      doors {
        id
        name
      }
    }
  }
`;

export const DELETE_DEVICE_GROUP = gql`
  mutation DeleteDeviceGroup($id: ID!) {
    deleteLocation(id: $id) {
      id
    }
  }
`;

export const UNASSIGN_DEVICE_GROUP_FROM_ACCESS_GRANTS = gql`
  mutation UnassignDeviceGroupFromAccessGrants($accessGrantIds: [ID!]!, $doorIds: [ID!]!, $locationIds: [ID!]!) {
    unassignFromAccessGrants(accessGrantIds: $accessGrantIds, doorIds: $doorIds, locationIds: $locationIds) {
      id
      locations {
        id
      }
    }
  }
`;

export const UPDATE_VISITOR_GROUP_V2 = gql`
  mutation UpdateVisitorGroupV2($visitorGroupId: ID!, $name: String!, $maxNumberOfMembers: Int) {
    updateVisitorGroup(visitorGroupId: $visitorGroupId, name: $name, maxNumberOfMembers: $maxNumberOfMembers) {
      id
      name
      members {
        id
        name
        email
        mobileDevices {
          id
          isRegistered
          registrationToken
          registrationDate
          role
        }
        isEditable
        expirationDate
        isAdmin
        visitorGroupMembership {
          visitorGroup {
            id
            type
          }
          role
          expirationDate
        }
      }
      type
      externalRef
      maxNumberOfMembers
    }
  }
`;

export const ADD_VISITORS_TO_VISITOR_GROUP = gql`
  mutation AddVisitorsToVisitorGroup($visitorGroupId: ID!, $memberships: [GroupMembershipInput!]!) {
    addVisitorsToVisitorGroup(visitorGroupId: $visitorGroupId, memberships: $memberships) {
      id
      name
      members {
        id
        name
        email
        mobileDevices {
          id
          isRegistered
          registrationToken
          registrationDate
          role
        }
        isEditable
        expirationDate
        isAdmin
        visitorGroupMembership {
          visitorGroup {
            id
            type
          }
          role
          expirationDate
        }
      }
      type
      externalRef
      maxNumberOfMembers
    }
  }
`;

export const UPDATE_VISITOR_GROUP_DETAILS_V2 = gql`
  mutation UpdateVisitorGroupDetailsV2($input: UpdateVisitorGroupDetailsInput!) {
    updateVisitorGroupDetails(input: $input) {
      id
      name
      maxNumberOfMembers
      isAdminGroup
      isQrCodeVisitInviterGroup
    }
  }
`;

export const UPDATE_DOOR_INFO = gql`
  mutation UpdateDoorInfo($name: String!, $doorId: ID!, $officeMode: UpdateDoorOfficeModeInput) {
    updateDoor(name: $name, doorId: $doorId, officeMode: $officeMode) {
      id
      locations {
        id
        name
      }
    }
  }
`;

export const ASSIGN_DOOR_TO_LOCATIONS = gql`
  mutation AssignDoorToLocations($name: String!, $doorId: ID!, $locationIds: [ID!]) {
    updateDoor(name: $name, doorId: $doorId, locationIds: $locationIds) {
      id
      locations {
        id
        name
      }
    }
  }
`;

export const ASSIGN_DEVICE_TO_ACCESS_GRANTS = gql`
  mutation AssignDeviceToAccessGrants($accessGrantIds: [ID!]!, $doorIds: [ID!]!, $locationIds: [ID!]!) {
    assignToAccessGrants(accessGrantIds: $accessGrantIds, doorIds: $doorIds, locationIds: $locationIds) {
      id
      doors {
        id
      }
    }
  }
`;

export const UNASSIGN_DEVICE_FROM_ACCESS_GRANTS = gql`
  mutation UnassignDeviceFromAccessGrants($accessGrantIds: [ID!]!, $doorIds: [ID!]!, $locationIds: [ID!]!) {
    unassignFromAccessGrants(accessGrantIds: $accessGrantIds, doorIds: $doorIds, locationIds: $locationIds) {
      id
      doors {
        id
      }
    }
  }
`;

export const BLOCK_ACCESS_CARD = gql`
  mutation BlockAccessCard($uuid: ID!, $reason: String!) {
    blockNfcCard(uuid: $uuid, reason: $reason) {
      uuid
      name
      updateRequired
      assignment {
        expiryDate
        expired
        blocked {
          since
          reason
        }
        visitor {
          id
          expirationDate
          email
          name
        }
        visitorName
      }
    }
  }
`;

export const DELETE_QR_CODE_VISIT = gql`
  mutation DeleteQrCodeVisit($qrCodeVisitId: ID!) {
    deleteQrCodeVisit(qrCodeVisitId: $qrCodeVisitId) {
      id
      status
    }
  }
`;

export const OPEN_DOOR = gql`
  mutation OpenDoor($doorId: ID!) {
    cloudController {
      openDoor(doorId: $doorId)
    }
  }
`;

export const IDENTIFY_READER = gql`
  mutation IdentifyReader($doorId: ID!) {
    cloudController {
      identifyReader(doorId: $doorId)
    }
  }
`;
